import ClipboardJS from 'clipboard';

// 拷贝文本
export const clipboardText = async (text: string) => {
  try {
    ClipboardJS.copy(text);
    await new Promise((resolve) => setTimeout(() => resolve(true), 500));

    return true;
  } catch (err) {
    return false;
  }
};
